<div class="modal-content w-note">
  <div class="modal-header">
    <h6 class="modal-title pull-left">{{ title }}</h6>
    <button type="button" class="close pull-right" aria-label="Close" (click)="decline()" id="confirm-modal-closeBtn">
      <em class="icon-close"></em>
    </button>
  </div>
  <div class="modal-history-header mb-3">
    @if (historyHeader) {
      <span>{{ historyHeader }}</span>
    } @else if (historyHeaders) {
      <span style="line-height: 24px" [innerHTML]="historyHeaders"></span>
    }
  </div>
  <div class="modal-body history-modal-body">
    <div class="row sticky-top">
      <div class="col-4 history-list-header">Edit Date</div>
      <div class="col-4 history-list-header">Activity</div>
      <div class="col-4 history-list-header">Edit By</div>
    </div>
    @if ((auditLogs ? auditLogs : (auditLogs$ | async))?.length > 0) {
      <div
        class="row"
        *ngFor="let auditLog of auditLogs ? auditLogs : (auditLogs$ | async); index as i"
        [ngClass]="{ 'mt-2': i !== 0 }"
      >
        <div class="col-4 history-list-text" id="editDate" data-id="editDate">
          {{ auditLog.editDate | amFromUtc | amLocal | dateDisplay: dateTimeDisplay }}
        </div>

        <div class="col-4 history-list-text" *ngIf="auditLog.activity; else activities">
          <div id="activity-req" data-id="activity-req" *ngIf="action === 'REQUEST'; else notRequestType">
            {{ historyType + '.HISTORY_ACTIVITY.' + auditLog.activity | translate: auditLog?.parameters }}
          </div>
          <ng-template #notRequestType>
            <div id="activity" data-id="activity">
              {{ getActivityLabel(auditLog.activity) }}
            </div>
          </ng-template>
          <div id="activityDetail" data-id="activityDetail" class="history-list-desc" *ngIf="auditLog.activityDetail">
            {{ auditLog.activityDetail }}
          </div>
          <div
            id="single-description"
            data-id="single-description"
            class="history-list-desc"
            *ngIf="auditLog.description"
          >
            - {{ auditLog.description }}
          </div>
          <div id="descriptions" data-id="descriptions" class="history-list-desc" *ngIf="auditLog.descriptions">
            <div *ngFor="let description of auditLog.descriptions; index as indexOfDescription">
              <ng-container *ngIf="description"
                ><span class="history-list-desc"> - {{ description }}</span></ng-container
              >
            </div>
          </div>
          <ng-container *ngIf="changesFormat === 'changes' && auditLog.changes">
            @if (changesByType()[i]?.roleNameChanged?.length) {
              <div class="history-list-desc mt-2">
                <span>- Change Role Name</span>
                <ul class="mb-0 pl-4">
                  @for (change of changesByType()[i].roleNameChanged; track change) {
                    <li>"{{ change.from }}" to "{{ change.to }}"</li>
                  }
                </ul>
              </div>
            }
            @if (changesByType()[i]?.permissionsAdded?.length) {
              <div class="history-list-desc mt-2">
                <span>- Add Permissions</span>
                @for (change of changesByType()[i].permissionsAdded; track change) {
                  <ul class="mb-0 pl-4">
                    @for (p of change.permissions ?? []; track p.code) {
                      <li>{{ p.name }}</li>
                    }
                  </ul>
                }
              </div>
            }
            @if (changesByType()[i]?.permissionsRemoved?.length) {
              <div class="history-list-desc mt-2">
                <span>- Remove Permissions</span>
                <ul class="mb-0 pl-4">
                  @for (change of changesByType()[i].permissionsRemoved; track change) {
                    @for (p of change.permissions ?? []; track p.code) {
                      <li>{{ p.name }}</li>
                    }
                  }
                </ul>
              </div>
            }
          </ng-container>
        </div>

        <!--Template for list activity-->
        <ng-template #activities>
          <div class="col-4 history-list-text">
            <div
              id="activities"
              data-id="activities"
              *ngFor="let activity of auditLog.activities; index as indexOfActivity"
            >
              <ng-container *ngIf="action === 'REQUEST'; else notRequestType">
                {{ historyType + '.HISTORY_ACTIVITY.' + activity.activity | translate }}
              </ng-container>
              <ng-template #notRequestType>
                {{ activity.activity }}
              </ng-template>
              <div class="history-list-desc" *ngIf="activity.descriptions">
                <div *ngFor="let description of activity.descriptions; index as indexOfDescription">
                  <ng-container *ngIf="description"
                    ><span id="description" data-id="description" class="history-list-desc">
                      - {{ description }}</span
                    ></ng-container
                  >
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <!--End Template for list activity-->

        <div class="col-4 history-list-text">
          <span id="editByName" data-id="editByName">{{ auditLog.editByName }}</span>
        </div>
      </div>
    } @else {
      <div class="row">
        <div class="col-4 history-list-text" id="editDate" data-id="editDate">-</div>

        <div class="col-4 history-list-text">-</div>
        <div class="col-4 history-list-text">
          <span id="editByName" data-id="editByName">-</span>
        </div>
      </div>
    }
  </div>
</div>
